<template>
    <div>
        <page-header title="لیست مدیران" create-url="/admins/create"></page-header>

        <search-filter :filters="filters" @search="search"></search-filter>

        <table-with-pagination v-if="admins"
                               :items="admins"
                               :headers="headers"
                               :default-page="parseInt($route.query.page ?? '1')"
                               @fetchPage="getAdmins"
                               @delete="deleteAdmin"
                               :actions="actions"
        ></table-with-pagination>
    </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import TableWithPagination from "@/components/General/TableWithPagination";
import SearchFilter from "@/components/General/SearchFilter.vue";

export default {
    name: "AdminsList",

    components: {SearchFilter, TableWithPagination, PageHeader},

    data() {
        return {
            headers: [
                {text: 'شناسه', value: 'id', align: 'center'},
                {text: 'نام', value: 'name', align: 'center'},
                {text: 'ایمیل', value: 'email', align: 'center'},
                {text: 'تاریخ آخرین بروز رسانی', value: 'persian_updated_at', align: 'center'},
                {text: 'تاریخ ایجاد', value: 'persian_created_at', align: 'center'},
                {text: 'عملیات', value: 'actions', align: 'center'},
            ],

            admins: null,

            actions: [
                {
                    icon: 'mdi-pencil',
                    color: 'warning',
                    route_name: 'update-admin',
                    route_param: 'id'
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    emit: 'delete',
                    identifier: 'id',
                    delete_confirm: true,
                }
            ],

            filters: [
                {
                    type: 'text',
                    name: 'name',
                    label: 'نام',
                },
                {
                    type: 'text',
                    name: 'email',
                    label: 'ایمیل',
                },
            ],
            searchValues: '',
        }
    },

    mounted() {
        this.getAdmins(parseInt(this.$route.query.page ?? "1"))
    },

    methods: {
        search(values) {
            this.$store.dispatch("objectParametersToString", values).then((result) => {
                this.searchValues = result
                this.getAdmins()
            })
        },

        getAdmins(page = 1) {
            this.$store.dispatch("getPaginatedAdmins", page + this.searchValues)
                .then((res) => {
                    this.admins = res.data
                })
        },

        deleteAdmin(slug) {
            this.$store.dispatch("deleteAdmin", slug)
                .then(() => {
                    this.getAdmins(this.admins.pagination.current_page)
                })
        }
    }
}
</script>

<style scoped>

</style>